<template>
  <el-container style="position: relative">
    <el-button
      @click="drawer = true"
      type="primary"
      circle
      style="position: fixed; top: 5px; left: 5px; z-index: 9"
      class="hidden-lg hidden-sm hidden-md"
    >
      <i class="fa-solid fa-bars"></i>
    </el-button>
    <el-aside width="115px" id="menuWrapper">
      <div
        style="
          position: fixed;
          text-align: center;
          width: 95px;
          border-right: 1px solid #ffffff;
          background: #000;
          height: 100vh;
        "
      >
        <DesktopMenu />
      </div>
    </el-aside>
    <el-drawer title="Menu" :visible.sync="drawer" direction="ltr">
      <div style="background: #000">
        <span>Menu</span>
        <DesktopMenu @click.native="drawer = false" />
      </div>
    </el-drawer>
    <el-container>
      <el-header class="headerTop" style="background: white; min-height: 75px">
        <el-row class="insideHeader" :gutter="15">
          <el-col :span="14">
            <div
              class="grid-content bg-purple-dark text-left"
              style="
                font-size: 14px;
                padding-left: 20px;
                text-align: left;
                clear: both;
              "
            >
              <div style="height: 40px; padding-top: 3px">
                <!-- <img src="@/assets/logo-main.png" class="hidden-xs" style="height: 30px;" /> -->
                <transition name="slide-fade" mode="out-in">
                  <span :key="$route.name" id="pageTitle">
                    {{ $route.name }}
                  </span>
                </transition>
                <div style="color: grey">{{ $route.meta.description }}</div>
                <div style="clear: both"></div>
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <div
              class="grid-content"
              style="text-align: right; padding-top: 3px"
            >
              <!-- <el-button
                v-if="domainName !== 'ADMIN'"
                type="info"
                class="noButtonStyle"
                plain
                size="small"
                round
                @click="$router.push({ name: 'Account' })"
              >
                <i class="fas fa-user-circle" style="font-size: 24px"></i>
                <br />Account
              </el-button> -->
              <!-- <el-badge :value="unread" class="item" :hidden="!unread">
                <el-button
                  v-if="domainName !== 'ADMIN'"
                  type="info"
                  class="noButtonStyle"
                  plain
                  size="small"
                  round
                  @click="$router.push({ name: 'Admin Messages' })"
                >
                  <i class="fas fa-envelope" style="font-size: 18px;"></i>
                  <br />Messages
                </el-button>
              </el-badge> -->
              <el-button
                class="noButtonStyle"
                size="small"
                type="info"
                plain
                round
                @click="$router.push({ name: 'Logout' })"
              >
                <i class="fas fa-sign-out-alt" style="font-size: 24px"></i>
                <br />Logout
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <transition name="slide-fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </el-main>
    </el-container>
    <el-dialog
      title="Terms & conditions"
      :visible.sync="showTermsModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div>
        <p>{{ termsContent }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agreeWithTerms">Confirm</el-button>
      </span>
    </el-dialog>

    <modals-container />
  </el-container>
</template>

<script>
import ApiService from "../services/ApiService";
// import HeaderComponent from "@/components/HeaderComponent";
import DesktopMenu from "@/components/DesktopMenu.vue";
export default {
  name: "maintemplate",
  components: { DesktopMenu },
  data() {
    return {
      drawer: false,
      showTermsModal: false,
      termsContent: "",
    };
  },
  computed: {
    domainName() {
      if (!this.$store.state.user) {
        return null;
      }
      if (this.$store.state.user.domain) {
        return this.$store.state.user.domain.name;
      } else {
        return this.$store.state.user.admin_type.name;
      }
    },
    unread() {
      return this.$store.state.unread_messages;
    },
  },
  // async beforeRouteEnter(to, from, next) {
  //   const result = await ApiService.userApi.getUserInfo();
  //   console.log("main template mounted");
  //   this.$store.dispatch("updateUserInfo", result.data);
  //   next();
  // },
  methods: {
    async getUserInfo() {
      try {
        const result = await ApiService.userApi.getUserInfo();
        this.$store.dispatch("updateUserInfo", result.data);
        // ApiService.generalApi.unreadAdminMessagesCount().then((resp) => {
        //   this.$store.dispatch("updateUnreadCount", resp.data.count);
        // });
      } catch (error) {
        if (error.response.status === 401) {
          this.$router.push({ name: "login" });
        }
      }
    },
    tryStopLoading() {
      const timeAfter10s = Math.round(new Date().getTime() / 1000) - 10;
      if (timeAfter10s > this.$store.state.general.loading_started) {
        this.$store.dispatch("loading", false);
      }
    },
    agreeWithTerms() {
      this.showTermsModal = false;
      ApiService.generalApi.hideTermsModal();
    },
  },
  created() {
    // ApiService.generalApi.unreadAdminMessagesCount().then((resp) => {
    //   this.$store.dispatch("updateUnreadCount", resp.data.unread);
    // });
    ApiService.generalApi.getOrganizationSettings().then((resp) => {
      // this.$store.state.general.
      if (resp.data && resp.data.termsConditions) {
        this.showTermsModal = true;
        this.termsContent = resp.data.termsConditions;
      }
    });
    // this.getUserInfo();
    // ApiService.userApi.accountStatusRedirect();
  },
};
</script>

<style lang="scss" scoped>
#template {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #888;
  background: none;
}
#main {
  margin-top: 45px;
  background: none;
  padding: 0px; // TEMP!
  &.noMargin {
    margin-top: 0px;
  }
}
.slide-fade-enter-active {
  transition: all 0.4s ease;
}
.slide-fade-leave-active {
  animation: 0;
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
  -webkit-transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  position: relative;
  transform: translateX(7px);
  -webkit-transform: translateX(7px);
  opacity: 0;
}
// .slide-fade-leave-active .vue-sticky-el {
</style>
<style>
.slide-fade-leave-active .vue-sticky-el {
  /* display: none !important; */
  position: absolute !important;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  width: 100% !important;
  opacity: 0;
  position: absolute;
  /* background: red; */
  /* opacity: 0.4 !important; */
}
.slide-fade-leave-active .vue-sticky-placeholder {
  width: 100% !important;
  height: 111px;
  opacity: 0;
  /* position: absolute; */
}
.redTheme {
  background: linear-gradient(35deg, #91005c, #ff72ad);
}
.purpleTheme {
  background: linear-gradient(45deg, #4d016b, #f1b5f5);
}
.greenTheme {
  background: linear-gradient(45deg, #094001, #d8f19c);
}
.lightGreenTheme {
  background: linear-gradient(45deg, #0d9a49, #a4e908);
}
.orangeTheme {
  background: linear-gradient(45deg, #d47500, #fdce6d);
}
.darkBlueTheme {
  background: linear-gradient(45deg, #001434, #23cddc);
}
.lightBlueTheme {
  background: linear-gradient(45deg, #0d9ce4, #53e5de) !important;
  color: white !important;
}
.headerTop {
  margin-left: -30px;
  border-bottom: 1px solid #e3e3e3;
}
.headerTop .insideHeader {
  font-size: 12px;
  /* border-bottom: 1px solid #f1f1f1; */
  padding: 5px;
  /* margin: 5px; */
  /* margin-top: 10px; */
}
.headerTop #pageTitle {
  font-family: inherit;
  /* font-weight: bold; */
  font-size: 18px;
  vertical-align: top;
  color: #3f9eff;
  display: inline-block;
  line-height: 34px;
  font-weight: 600;
}
.headerTop .insideHeader img {
  max-height: 40px;
  vertical-align: middle;
  /* opacity: 0.7; */
}
.headerTop .block {
  /* box-shadow: 0px 0px 5px #bbb; */
  text-align: center;
  background: none;
  min-height: 50px;
}
.headerTop .noButtonStyle {
  /* color: red; */
  padding-left: 10px !important;
  padding-right: 0px !important;
  padding-top: 4px !important;
  padding-bottom: 2px !important;
  font-size: 11px;
}
.headerTop .noButtonStyle span {
  /* color: #bfbfbf; */
}
@media only screen and (max-width: 650px) {
  #menuWrapper {
    display: none !important;
  }
  .headerTop {
    margin-left: 0px;
  }
}
</style>
